/**
 * @desc 手动上传水单附件
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.PayUploadBillFileRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/paymentMaster/uploadBillFileByPyNo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
